import { DEFAULT_FONTS, FontRole, KEEPO_FONTS } from "@keepoinc/site-page-react-component";

/** The fonts that are free (any other is PLUS): the ones every Keepo always had. */
export const isFreeFont = (id: string, role: FontRole) => id === DEFAULT_FONTS[role];

/**
 * Every font of the catalog, only the letters of their names (and "Aa"): enough to write each option of the
 * picker in its own font, without loading 20 whole fonts.
 */
export const catalogFontsUrl = () => {
  const letters = [...new Set(["Aa", ...KEEPO_FONTS.map(font => font.name)].join("").replace(/ /g, ""))].join("");
  const families = KEEPO_FONTS.map(font => `family=${font.name.replace(/ /g, "+")}`).join("&");
  return `https://fonts.googleapis.com/css2?${families}&text=${encodeURIComponent(letters)}&display=swap`;
};

/**
 * Puts the stylesheet `href` in the document under `key` (nothing when it's the latest there). The one it had leaves
 * only once the new one loaded: meanwhile its fonts stay, so nothing flashes in another font.
 */
export const setStylesheet = (doc: Document, key: string, href: string) => {
  const links = () => [...doc.head.querySelectorAll<HTMLLinkElement>(`link[data-keepo-fonts="${key}"]`)];
  if (links().at(-1)?.getAttribute("href") === href) return;
  const link = doc.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.dataset.keepoFonts = key;
  link.addEventListener("load", () => links().forEach(other => other !== link && other.remove()));
  // not loaded (offline): the ones it had stay
  link.addEventListener("error", () => link.remove());
  doc.head.appendChild(link);
};
